import React, { useEffect } from 'react'
import useApp from '../../store/app/appContext';
import PageWrapper from '../../containers/app/PageWrapper';
import { useParams, useLocation } from 'react-router' 
import ViewPatientDetails from '../../containers/patients/ViewPatientDetails';
import UsersProvider from '../../store/users/usersProvider';
import AddPatient from '../../containers/patients/AddPatient';

function PatientDetails() {
  const { id } = useParams(); 
  const location = useLocation();

  const { appState: { user }} = useApp();
  const [pageTitle, setPageTitle] = React.useState('');

  const addPatient = location.pathname.includes('/add');

  useEffect(() => {
    if (id) setPageTitle('Patient details');
    if (addPatient) setPageTitle('Add patient');
  }, [])

  if (!user) return '';
  if (!user._id) return '';

  return (
    <UsersProvider>
      <PageWrapper navbar title={pageTitle}>
        {id && <ViewPatientDetails patientId={id}/>}
        {addPatient && <AddPatient />}
      </PageWrapper>
    </UsersProvider>
  )
}

export default PatientDetails;